import React from 'react';

import { LinkV2 } from '../../../LinkV2';

import { Container } from './ZolaTermsPrivacy.styles';

type ZolaTermsPrivacyProps = {
  className?: string;
};

const ZolaTermsPrivacy = ({ className }: ZolaTermsPrivacyProps): JSX.Element => {
  return (
    <Container className={className}>
      By creating your Zola account you agree to our{' '}
      <LinkV2 inline href="/terms" target="_blank" rel="noopener noreferrer">
        Terms of use
      </LinkV2>{' '}
      and{' '}
      <LinkV2 inline href="/privacy" target="_blank" rel="noopener noreferrer">
        Privacy policy
      </LinkV2>
      .
    </Container>
  );
};

export default ZolaTermsPrivacy;
